import { render, staticRenderFns } from "./MarketTurntable.vue?vue&type=template&id=43249c2a&scoped=true"
import script from "./MarketTurntable.vue?vue&type=script&lang=js"
export * from "./MarketTurntable.vue?vue&type=script&lang=js"
import style0 from "./MarketTurntable.vue?vue&type=style&index=0&id=43249c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43249c2a",
  null
  
)

export default component.exports